import React, { useState } from "react";
import { TrendingUp, Loader2, Sparkles, DollarSign, Repeat, Target, Package, Megaphone } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

const SECTIONS = [
  { key: "pricing", label: "Pricing", icon: DollarSign },
  { key: "retention", label: "Retention", icon: Repeat },
  { key: "conversion", label: "Conversion", icon: Target },
  { key: "packaging", label: "Packaging", icon: Package },
  { key: "growth", label: "Growth", icon: Megaphone },
];

export default function GrowthAssistant({ gameId }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const run = async () => {
    setLoading(true);
    try { const { data } = await api.post(`/games/${gameId}/growth`); setData(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="rounded-2xl border border-[hsl(var(--primary))]/30 bg-[hsl(var(--primary))]/5 p-5 mb-6" data-testid="growth-assistant">
      <div className="flex items-center justify-between gap-2 mb-2">
        <h2 className="font-bold flex items-center gap-2"><TrendingUp className="w-4 h-4 text-[hsl(var(--primary))]" /> AI Growth & Monetisation Coach</h2>
        <Button size="sm" onClick={run} disabled={loading} className="rounded-full" data-testid="growth-run-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />} {data ? "Refresh tips" : "Get AI tips"}
        </Button>
      </div>
      <p className="text-xs text-[hsl(var(--muted-foreground))] mb-3">Friendly, kid-safe advice based on your game's real numbers — pricing, retention, conversion, packaging and growth.</p>
      {data && (
        <div data-testid="growth-result">
          {data.advice?.summary && <div className="rounded-xl bg-[hsl(var(--card))] border border-[hsl(var(--border))] p-3 text-sm mb-3">{data.advice.summary}</div>}
          <div className="grid sm:grid-cols-2 gap-3">
            {SECTIONS.map(({ key, label, icon: Icon }) => (data.advice?.[key]?.length ? (
              <div key={key} className="rounded-xl border border-[hsl(var(--border))] bg-[hsl(var(--card))] p-3" data-testid={`growth-${key}`}>
                <div className="font-semibold text-sm flex items-center gap-1.5 mb-1.5"><Icon className="w-3.5 h-3.5 text-[hsl(var(--primary))]" /> {label}</div>
                <ul className="space-y-1.5">
                  {data.advice[key].map((t, i) => <li key={i} className="text-xs text-[hsl(var(--muted-foreground))] flex gap-1.5"><span className="text-[hsl(var(--primary))]">•</span><span>{t}</span></li>)}
                </ul>
              </div>
            ) : null))}
          </div>
        </div>
      )}
    </div>
  );
}
